class ChooseNewPlan {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.changeDuration();
    }
    changeDuration(){
        const thisClass = this;
        let pricingContainer = document.querySelector('#kt_pricing');
        let containers = pricingContainer.querySelectorAll('[data-kt-change-plan="true"]');
        containers.forEach((container) => {
            let planPeriodMonthlyButton = container.querySelector('[data-kt-plan="monthly"]');
            let planPeriodAnnuallyButton = container.querySelector('[data-kt-plan="annually"]');

            // Handle period change
            planPeriodMonthlyButton.addEventListener('click', function (e) {
                e.preventDefault();
                planPeriodMonthlyButton.classList.add('active');
                planPeriodAnnuallyButton.classList.remove('active');
                thisClass.changePlanPrices('monthly');
                thisClass.changePlanLinks('monthly');
            });

            planPeriodAnnuallyButton.addEventListener('click', function (e) {
                e.preventDefault();
                planPeriodMonthlyButton.classList.remove('active');
                planPeriodAnnuallyButton.classList.add('active');
                thisClass.changePlanPrices('annually');
                thisClass.changePlanLinks('annually');
            });
        });
    }
    changePlanPrices(duration){
        let prices = [].slice.call(document.querySelectorAll('[data-kt-plan-price-monthly]'));
        prices.map(function (item) {
            let monthlyPrice = item.getAttribute('data-kt-plan-price-monthly');
            let annuallyPrice = item.getAttribute('data-kt-plan-price-annually');

            if ( duration === 'monthly' ) {
                item.innerHTML = '$'+monthlyPrice;
            } else if ( duration === 'annually' ) {
                item.innerHTML = '$'+annuallyPrice;
            }
        });

        let pricesBeforeDiscount = [].slice.call(document.querySelectorAll('[data-kt-plan-no-discount-price-monthly]'));
        pricesBeforeDiscount.map(function (item) {
            let monthlyPriceBeforeDiscount = item.getAttribute('data-kt-plan-no-discount-price-monthly');
            let annuallyPriceBeforeDiscount = item.getAttribute('data-kt-plan-no-discount-price-annually');

            if ( duration === 'monthly' ) {
                item.innerHTML = '$'+monthlyPriceBeforeDiscount;
            } else if ( duration === 'annually' ) {
                item.innerHTML = '$'+annuallyPriceBeforeDiscount;
            }
        });
    }
    changePlanLinks(duration){
        let links = [].slice.call(document.querySelectorAll('[data-kt-plan-link-monthly]'));
        links.map(function (item) {
            let monthlyLink = item.getAttribute('data-kt-plan-link-monthly');
            let annuallyLink = item.getAttribute('data-kt-plan-link-annually');

            if ( duration === 'monthly' ) {
                item.href = monthlyLink;
            } else if ( duration === 'annually' ) {
                item.href = annuallyLink;
            }
        });
    }
}
window.ChooseNewPlan = ChooseNewPlan;